<script setup lang="ts">
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { CrmDomeinVerificatieGetDomeinenPerAdviseurResponse as Domein } from '@services/crm-public/orval-api/model/crmDomeinVerificatieGetDomeinenPerAdviseurResponse';
import VColumn from '@shared/component/VDataTable/VColumn.vue';
import VDataTable from '@shared/component/VDataTable/VDataTable.vue';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import VHeading from '@shared/typography/VHeading/VHeading.vue';
import CheckStatusButton from './CheckStatusButton/CheckStatusButton.vue';

defineProps<{
  domeinen?: Domein[];
  isPending: boolean;
}>();
</script>

<template>
  <VHeading :level="2">Actuele statussen</VHeading>
  <VDataTable class="max-w-[50rem]" :value="isPending ? [{}] : (domeinen ?? [])">
    <VColumn field="domein" header="Domein">
      <template #body="{ data }">
        <VSkeleton v-if="isPending" />

        <template v-else>
          {{ data.domein }}
        </template>
      </template>
    </VColumn>

    <VColumn align="center" class="w-0" field="spfVerified" header="SPF-record">
      <template #body="{ data }">
        <VSkeleton v-if="isPending" class="min-w-16" />

        <FontAwesomeIcon
          v-else
          :class="{
            'text-red': !data.spfVerified,
            'text-green-600': data.spfVerified,
          }"
          :icon="data.spfVerified ? faCheck : faXmark"
        />
      </template>
    </VColumn>

    <VColumn align="center" class="w-0" field="dkimVerified" header="DKIM-record">
      <template #body="{ data }">
        <VSkeleton v-if="isPending" class="min-w-16" />

        <FontAwesomeIcon
          v-else
          :class="{
            'text-red': !data.dkimVerified,
            'text-green-600': data.dkimVerified,
          }"
          :icon="data.dkimVerified ? faCheck : faXmark"
        />
      </template>
    </VColumn>

    <VColumn align="right" class="w-0" field="">
      <template #body="{ data }">
        <VSkeleton v-if="isPending" class="min-w-16" />

        <CheckStatusButton v-else :domain="data.domein" />
      </template>
    </VColumn>
  </VDataTable>
</template>
